import React from 'react';
import {ThemeProvider} from 'styled-components';
import lightTheme from './theme/lightTheme';
import GlobalLoading from './connected-components/loading';
import AppRouter from './route';
import GlobalToast from './connected-components/toast';
import {I18nextProvider} from 'react-i18next';
import i18n from './translation/i18n';
import GlobalModal from './connected-components/globalModal';
import {GlobalStyle} from './styles';

const App = () => {
  const theme = lightTheme();

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AppRouter />
        <GlobalToast />
        <GlobalLoading />
        <GlobalModal />
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default App;
